import { Button, Modal } from '@palmetto/palmetto-components';
import { DateTime } from 'luxon';

export const AcceptPendingPlanChangeModal = ({
  isModalOpen,
  handleCloseModal,
  dataIsUpdating,
  updateFunction,
  effectiveDate,
}: {
  isModalOpen: boolean;
  handleCloseModal: () => void;
  dataIsUpdating: boolean;
  updateFunction: () => Promise<void>;
  effectiveDate?: Date;
}) => {
  const title = 'Accept Payment Plan Proposal';
  const confirmationText = `In accordance with the Amendments; Waiver; Consent; Approval section of the master agreement you executed with LightReach, 
    we hereby amend Exhibit 3 Milestones and Payment Schedule. You shall be deemed to accept the terms of this Milestones and Payment Schedule 
    on the date you click Accept Proposal below, or ${effectiveDate ? DateTime.fromISO(effectiveDate.toString()).toUTC().toFormat('MM/dd/yyyy') : ''}, whichever is sooner.`;

  return (
    <Modal ariaLabelledBy="titleBasic" isOpen={isModalOpen} onDismiss={handleCloseModal} maxWidth="5xl">
      <Modal.Header id="titleBasic" title={title} onDismiss={handleCloseModal} />
      <Modal.Body childGap="md" background="secondary">
        {confirmationText}
      </Modal.Body>
      <Modal.Footer justifyContent="space-between">
        <Button
          onClick={handleCloseModal}
          variant="secondary"
          tone="neutral"
          isDisabled={dataIsUpdating}
          isLoading={dataIsUpdating}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          className="shadow-xs"
          onClick={updateFunction}
          style={{ whiteSpace: 'nowrap' }}
          isDisabled={dataIsUpdating}
          isLoading={dataIsUpdating}
        >
          Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
